// Global Instructions Rule Applied!

import {
  DealTarget,
  FilterValue,
  SortConfig,
  SetFilterOptionsAction,
  SetDealsAction,
  SetActiveFiltersAction,
  SetActiveSortingAction,
  ClearActiveFiltersAction,
  UpdateDealRecordAction,
  AddDealAction,
  UpdateDealRoundAction,
  RemoveDealFromListAction
} from '../../interfaces/deals.ts'
import { DealsPaginatedResponse } from '../../../app_modules/deals/services/dealsService.ts'
import { TableFilterOptionsResponse } from '../../rpc_models/get_table_filter_options_response.ts'
import { DealRecord } from '../../data_models/deal_record.ts'
import {
  SET_FILTER_OPTIONS,
  SET_DEALS,
  SET_ACTIVE_FILTERS,
  SET_ACTIVE_SORTING,
  CLEAR_ACTIVE_FILTERS,
  UPDATE_DEAL_RECORD,
  ADD_DEAL,
  UPDATE_DEAL_ROUND,
  REMOVE_DEAL_FROM_LIST
} from './constants.ts'

export const setFilterOptions = ({
  response,
  target
}: {
  response: TableFilterOptionsResponse
  target: DealTarget
}): SetFilterOptionsAction => ({
  type: SET_FILTER_OPTIONS,
  payload: { response, target }
})

export const setDeals = ({
  response,
  target
}: {
  response: DealsPaginatedResponse
  target: DealTarget
}): SetDealsAction => ({
  type: SET_DEALS,
  payload: { response, target }
})

export const setActiveFilters = ({
  filters,
  target
}: {
  filters: FilterValue[]
  target: DealTarget
}): SetActiveFiltersAction => ({
  type: SET_ACTIVE_FILTERS,
  payload: { filters, target }
})

export const setActiveSorting = ({
  sorting,
  target
}: {
  sorting: SortConfig[]
  target: DealTarget
}): SetActiveSortingAction => ({
  type: SET_ACTIVE_SORTING,
  payload: { sorting, target }
})

export const clearActiveFilters = ({ target }: { target: DealTarget }): ClearActiveFiltersAction => ({
  type: CLEAR_ACTIVE_FILTERS,
  payload: { target }
})

export const updateDealRecord = ({
  dealId,
  updates
}: {
  dealId: string
  updates: Record<string, any>
}): UpdateDealRecordAction => ({
  type: UPDATE_DEAL_RECORD,
  payload: { dealId, updates }
})

export const addDeal = ({ deal }: { deal: DealRecord }): AddDealAction => ({
  type: ADD_DEAL,
  payload: { deal }
})

export const updateDealRound = ({
  roundId,
  updates
}: {
  roundId: string
  updates: Record<string, any>
}): UpdateDealRoundAction => ({
  type: UPDATE_DEAL_ROUND,
  payload: { roundId, updates }
})

export const removeDealFromList = ({ dealId }: { dealId: string }): RemoveDealFromListAction => ({
  type: REMOVE_DEAL_FROM_LIST,
  payload: { dealId }
})
